import { AxiosService } from './axios.service'
import { SearchService } from './search.service'
import { maskHelper } from './../helpers/mask.helper'
import {
	paginationErrorHandler,
	paginationSuccessHandler,
} from './pagination-handlers'

/**
 * Defines the API methods for admin reports
 */
export class AdminReportsService extends SearchService {
	static baseURL = 'admin/relatorios'

	/**
	 * Searches the moveflex clients
	 * @return {Promise<any[]>} List of employees
	 */
	static searchClients(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/pesquisar-clientes`,
			{
				params,
			}
		)
			.then(({ data }) => ({
				rows: data.data.map(({ phone, ...props }) => ({
					...props,
					phone: maskHelper.applyPhone(phone),
				})),
				totalRows: super.getTotalRows(data.data),
			}))
			.catch(paginationErrorHandler)
	}

	/**
	 * Searches the names of the moveflex clients
	 * @return {Promise<any[]>} List of users
	 */
	static searchClientsNames(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/pesquisar-nomes-dos-clientes`,
			{
				params,
			}
		)
			.then(({ data }) => ({
				rows: data.data,
				totalRows: super.getTotalRows(data.data),
			}))
			.catch(paginationErrorHandler)
	}

	/**
	 * Searches extract of points of an user
	 * @return {Promise<any[]>} List of transactions
	 */
	static searchExtractOfPoints(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/pesquisar-extrato-de-pontos`,
			{
				params,
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Get sales/revenue report
	 * @return {Promise<any[]>} List of transactions
	 */
	static getSalesAndRevenueReport(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/pesquisar-vendas`,
			{
				params,
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Get sales/revenue report's total points and total value
	 * @return {Promise<any[]>} totalPoints and totalValue
	 */
	static getTotalPointsAndTotalValue(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/calcular-totais`,
			{
				params,
			}
		).then(({ data }) => data)
	}

	/**
	 * Get points breakage report's
	 * @return {Promise<any[]>} totalPoints and totalValue
	 */
	static getPointsBreakage(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/breakage-pesquisar-extrato-de-pontos`,
			{
				params,
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Get moveflex club report's
	 * @return {Promise<any[]>}
	 */
	static getClubReport = (params) =>
		AdminReportsService.defaultPaginationGetMethod(
			params,
			`${AdminReportsService.baseURL}/pesquisar-clube-moveflex`
		)

	static defaultPaginationGetMethod = (params, url) => {
		return AxiosService.get(url, {
			params,
		})
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Searches the cards that have been proposed
	 * @return {Promise<any[]>} List of card proposals
	 */
	static searchCardProposals(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/pesquisar-solicitacoes-cartao`,
			{
				params,
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Searches the invoices
	 * @return {Promise<any[]>} List of invoices
	 */
	static searchInvoices(params) {
		return AxiosService.get(
			`${AdminReportsService.baseURL}/pesquisar-faturas`,
			{
				params,
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}
}
